import { useContext, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import PageDataContext from '../context/PageDataContext';

export const RedirectPage = () => {
    const { isLoading, isMostRecentStored, mostRecentPageData } = useContext(PageDataContext);
    const navigate = useNavigate();

    useEffect(() => {
        if (!isLoading) {
            if (isMostRecentStored) {
                navigate(mostRecentPageData.pathname, {
                    state: { loadMostRecentPageData: 'true' },
                    replace: true,
                });
            } else {
                navigate('/hosts', { replace: true });
            }
        }
    }, [isLoading]);

    return <></>;
};
